import { toMoney } from '@/general/src/other/money.js'
import { getTxDescription, getTxStatusLabel } from '@/general/src/subscription/utils.shared.js'
import { adminAgentEditRoute } from '@/webapp/src/lib/routes.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Link, Table } from '@/webapp/src/lib/uninty.components.js'
import { formatDate } from 'date-fns/format'

export const TxsForAdmin = ({ agentSn, agentId }: { agentSn?: number; agentId?: string }) => {
  return (
    <SectionWrapper
      useInfiniteQuery={() =>
        trpc.getTxsForAdmin.useInfiniteQuery(
          { agentSn, agentId },
          {
            refetchInterval: 60 * 1000 * 5,
            getNextPageParam: (lastPage) => {
              return lastPage.nextCursor
            },
          }
        )
      }
      showLoaderOnFetching={false}
      setProps={({ infiniteQueryResult }) => ({
        txs: infiniteQueryResult.data?.pages.flatMap((page) => page.txs) ?? [],
        infiniteQueryResult,
      })}
    >
      {({ txs, infiniteQueryResult }) => {
        if (txs.length === 0) {
          return <p>Пока не было транзакций</p>
        }
        return (
          <Table
            records={txs}
            columns={[
              { heading: 'SN', body: (record) => record.sn, width: 70 },
              {
                heading: 'Агент',
                body: (record) => (
                  <Link href={adminAgentEditRoute.get({ agentSn: record.agent.sn })}>{record.agent.sn}</Link>
                ),
                width: 150,
              },
              { heading: 'Дата', body: (record) => formatDate(record.createdAt, 'dd.MM.yyyy HH:mm'), width: 150 },
              { heading: 'Статус', body: (record) => getTxStatusLabel(record.status), width: 120 },
              { heading: 'Сумма', body: (record) => toMoney({ amount: record.amount }), width: 100 },
              { heading: 'Назначение', body: (record) => getTxDescription(record), width: 400 },
              { heading: 'Дополнительно', body: (record) => record.failureReason || '—', width: 400 },
            ]}
            loadMore={() => {
              if (!infiniteQueryResult.isFetchingNextPage && infiniteQueryResult.hasNextPage) {
                void infiniteQueryResult.fetchNextPage()
              }
            }}
            hasMore={infiniteQueryResult.hasNextPage}
          />
        )
      }}
    </SectionWrapper>
  )
}
